import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  NgZone,
  OnDestroy,
  Output,
} from '@angular/core';

export interface ResizedEvent {
  newRect: DOMRectReadOnly;
  oldRect?: DOMRectReadOnly;
}

@Directive({
  selector: '[bulbResizeObserver]',
  standalone: false,
})
export class ResizeObserverDirective implements AfterViewInit, OnDestroy {
  @Output() resized = new EventEmitter<ResizedEvent>();

  private observer?: ResizeObserver;

  private previousRect?: DOMRectReadOnly;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private ngZone: NgZone,
  ) {}

  ngAfterViewInit() {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      this.observer = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (!entry) {
          return;
        }

        const newRect = entry.contentRect;
        const oldRect = this.previousRect;
        this.previousRect = newRect;

        this.ngZone.run(() => {
          this.resized.emit({ newRect, oldRect });
        });
      });

      this.observer.observe(this.elementRef.nativeElement);
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
